"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dezoitoAnosAtras = exports.stringPercentToNumber = exports.stringToNumber = exports.onlyNumbers = void 0;
const onlyNumbers = (number_str = '') => number_str.replace(/\D/g, '');
exports.onlyNumbers = onlyNumbers;
const stringToNumber = (numberStr) => {
    const numero = Number(numberStr.toString().replace(/\./g, '').replace(',', '.'));
    if (Number.isNaN(numero)) {
        return 0;
    }
    return numero;
};
exports.stringToNumber = stringToNumber;
const stringPercentToNumber = (numberStr, casasDecimais = 2) => {
    const numero = exports.stringToNumber(numberStr) / 100;
    return Number(numero.toFixed(casasDecimais));
};
exports.stringPercentToNumber = stringPercentToNumber;
const dezoitoAnosAtras = () => {
    const data = new Date();
    data.setFullYear(data.getFullYear() - 18);
    return data;
};
exports.dezoitoAnosAtras = dezoitoAnosAtras;
//# sourceMappingURL=index.js.map